export default "__VITE_ASSET__BvBwNyJR__"